import { Result } from 'antd';
import { Button } from '@bettercomp/ui-components';
import { lookupDeniedCopy, navigateExternal } from '@bettercomp/ams-spa-auth';
import { useAuthContext } from './AuthContext';

export interface DeniedViewProps {
  /** The denied route's `source` query parameter, null when absent. */
  source: string | null;
  /** The denied route's `code` query parameter, null when absent. */
  code: string | null;
}

export function DeniedView({ source, code }: DeniedViewProps) {
  const { session } = useAuthContext();
  const copy = lookupDeniedCopy({ source, code });

  // A refusal leaves the hosted-UI session behind, so the only way to a different
  // account is a real sign-out. Without a session there is nothing to end, and the
  // button is withheld rather than wired to nothing.
  const handleSignOut = () => {
    void session?.logout().then(navigateExternal);
  };

  return (
    <Result
      status="403"
      title={copy.title}
      subTitle={copy.description}
      extra={
        session ? (
          <Button type="primary" onClick={handleSignOut}>
            Sign out
          </Button>
        ) : undefined
      }
    />
  );
}
